export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9304.6db91ab9.jpg";